import Connections from '../../connections';
import {
  action,
  observable,
} from 'mobx';
import {
  getWheelPrizes,
  getWheelPrize,
  createWheelPrize,
  getWheelEvents,
  getWheelEvent,
  getWheelEventWinners,
  getWheelEventsGroups,
  getWheelEventsGroup,
  getWheelEventWinnersCsv,
  retryPointsSubmittion,
} from "../../axios/requests";

import { RequestStatus } from "mobx-store";
import {
  WheelEvent,
  WheelEventsGroup,
  WheelWinner,
} from "mobx-store/storeInterfaces/wheelFortuneInterface";
import { PrizeDTO } from "screens/wheelOfFortuneScreens/DtO/prizeDTO";
import {
  PrizeToUpdate,
  PrizeType,
} from "screens/wheelOfFortuneScreens/DtO/prizeFormViewModel";
import { EventDTO } from "screens/wheelOfFortuneScreens/DtO/eventDTO";
import { DefaultLanguage } from "constants/languages";
import { getHeader } from "helperFunctions/getHeader";
import { Pagintation } from "screens/wheelOfFortuneScreens/types";
import { saveAs } from "file-saver";
import { uploadSingleFile } from "helperFunctions/uploadService";
import {
  FieldFileCommonTypes,
  RemoteFile,
} from "components/GeneralFormView/FormField/types";

export class WheelFortuneStore {
  @observable prizes: PrizeDTO[] = [];
  @observable events: WheelEvent[] = [];
  @observable winners: WheelWinner[] = [];
  @observable event: WheelEvent;
  @observable prize: PrizeDTO;
  @observable createAndUpdateStatus: RequestStatus = RequestStatus.IDLE;
  @observable status: RequestStatus = RequestStatus.IDLE;
  @observable winnersCount = 0;
  @observable eventsGroups: WheelEventsGroup[] = [];
  @observable retryPointsStatus: { [key: number]: RequestStatus } = {};
  @observable promoCodeGroups: { name: string; promoCodeGroupId: number }[] =
    [];
  @action.bound
  public async getWheelEventWinners(
    eventId: number,
    pagination: Pagintation,
    langCode: string = DefaultLanguage
  ): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getWheelEventWinners(
          eventId,
          pagination.pageNumber,
          pagination.pageSize
        ),
        getHeader(langCode)
      );
      const { wheelWinners, count } = response?.data;
      this.winners = wheelWinners || [];
      this.winnersCount = count;
      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      this.status = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async retryDeglawyPoints(
    eventId: number,
    wheelWinnerId: number,
    langCode: string
  ) {
    try {
      await Connections.wadiDeglaAxios.httpPost(
        retryPointsSubmittion(eventId, wheelWinnerId),
        getHeader(langCode)
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }

  @action.bound
  public async getWheelEventWinnersCsv(eventId: number) {
    try {
      return Connections.wadiDeglaAxios.httpGet(
        getWheelEventWinnersCsv(eventId),
        {
          responseType: "blob",
          headers: {
            "x-apicache-bypass": true,
          },
        }
      );
    } catch (error) {
      return Promise.reject(error);
    }
  }

  @action.bound
  public async getWheelEventsGroups(): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getWheelEventsGroups
      );
      this.eventsGroups = response?.data || [];
      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      this.status = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }
  @action.bound
  public async addEventsGroup(values: WheelEventsGroup): Promise<void> {
    try {
      this.createAndUpdateStatus = RequestStatus.LOADING;
      await Connections.wadiDeglaAxios.httpPost(getWheelEventsGroups, {
        eventGroupTitle: values.eventGroupTitle,
      });
      this.createAndUpdateStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.createAndUpdateStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }
  @action.bound
  public async updateEventsGroup(
    id: number,
    values: WheelEventsGroup
  ): Promise<void> {
    try {
      this.createAndUpdateStatus = RequestStatus.LOADING;
      await Connections.wadiDeglaAxios.httpPut(getWheelEventsGroup(id), {
        eventGroupTitle: values.eventGroupTitle,
      });
      this.createAndUpdateStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.createAndUpdateStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }
  @action.bound
  public async getWheelEvents(
    langCode: string = DefaultLanguage
  ): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getWheelEvents,
        getHeader(langCode)
      );
      this.events = response?.data || [];
      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      this.status = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async getWheelEventById(
    eventId: number,
    langCode: string = DefaultLanguage
  ): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getWheelEvent(eventId),
        getHeader(langCode)
      );
      this.event = response?.data || {};
      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      this.status = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async createEvent(
    event: EventDTO,
    langCode: string = DefaultLanguage
  ): Promise<number> {
    try {
      this.createAndUpdateStatus = RequestStatus.LOADING;
      delete event.eventId;
      const response = await Connections.wadiDeglaAxios.httpPost(
        getWheelEvents,
        event,
        getHeader(langCode)
      );
      this.createAndUpdateStatus = RequestStatus.SUCCESS;
      return response.data;
    } catch (error) {
      this.createAndUpdateStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async updateEvent(
    eventId: number,
    event: EventDTO,
    langCode: string = DefaultLanguage
  ): Promise<void> {
    try {
      this.createAndUpdateStatus = RequestStatus.LOADING;
      delete event.eventId;
      const response = await Connections.wadiDeglaAxios.httpPut(
        getWheelEvent(eventId),
        event,
        getHeader(langCode)
      );
      this.createAndUpdateStatus = RequestStatus.SUCCESS;
    } catch (error) {
      this.createAndUpdateStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async getWheelPrizes(eventId: number): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getWheelPrizes(eventId)
      );
      this.prizes = response?.data || [];
      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      this.status = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async getWheelPrize(
    prizeId: number,
    language = DefaultLanguage
  ): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      const response = await Connections.wadiDeglaAxios.httpGet(
        getWheelPrize(prizeId),
        getHeader(language)
      );
      this.prize = response?.data;

      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      this.status = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async createPrize(
    eventId: number,
    prize: PrizeDTO
  ): Promise<{ prizeId: number }> {
    try {
      this.createAndUpdateStatus = RequestStatus.LOADING;
      delete prize.prizeId;
      const response = await Connections.wadiDeglaAxios.httpPost(
        createWheelPrize(eventId),
        await this.prizeToSend(prize)
      );
      this.createAndUpdateStatus = RequestStatus.SUCCESS;
      return response.data;
    } catch (error) {
      this.createAndUpdateStatus = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  @action.bound
  public async updatePrize(
    prizeId: number,
    body: PrizeToUpdate,
    language: string
  ): Promise<void> {
    try {
      this.status = RequestStatus.LOADING;
      await Connections.wadiDeglaAxios.httpPut(
        getWheelPrize(prizeId),
        body,
        getHeader(language)
      );
      const selectedPrize = this.prizes.find((p) => p.prizeId === prizeId);
      if (selectedPrize) {
        selectedPrize.isActive = body.isActive;
      }
      this.status = RequestStatus.SUCCESS;
    } catch (error) {
      this.status = RequestStatus.FAILED;
      return Promise.reject(error);
    }
  }

  private async prizeToSend(prize: PrizeDTO): Promise<PrizeDTO> {
    const prizeToSend: PrizeDTO = {
      backgroundImageUrl: "https://dummyimage.com/600x400/000/fff",
      type: prize.type,
      backgroundColor: prize.backgroundColor,
      isActive: prize.isActive,
      maxWinners: prize.maxWinners,
      value: prize.value,
      weight: prize.weight,
      textImage: prize.textImage,
    };
    if ([PrizeType.WIFI_PACKAGE].includes(prizeToSend.type)) {
      prizeToSend.prizeWifi = prize.prizeWifi;
    }
    return prizeToSend;
  }
}
